var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaTopSwirlinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 708 92.6",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#103559",
    d: "M433.8 42.7c-163.7 64.4-327.6 55-404.2 19.2-11.5-5.4-22-10.6-31.5-15.6v354.4l712.1-1.2.5-338C672.3 33.6 564.2-8.6 433.8 42.7z"
  })));
}
export default SvgCtaTopSwirlinline;